'use client'

import React from 'react'
import clsx from 'clsx'
import { ERROR_MESSAGES } from '@/constants/messages'
import SearchInputSuggestions from '@/components/Shared/SearchInputSuggestions'
import styles from '../styles.module.scss'

const { HEADING, DESCRIPTIONS, SEARCH_LABEL } = ERROR_MESSAGES.PAGE.NOT_FOUND

export default function Error404() {
  return (
    <div className={clsx(styles.errorContent, styles.error404)}>
      <div className={styles.errorSection}>
        <h1 className={clsx(styles.errorCode, styles.error)}>404</h1>
        <div className={styles.messageSection}>
          <h2 className={styles.errorHeading}>{HEADING}</h2>
          <p className={styles.errorDescription}>
            {DESCRIPTIONS.map((text, i) => (
              <React.Fragment key={i}>
                {i > 0 && <br />}
                {text}
              </React.Fragment>
            ))}
          </p>
        </div>
      </div>
      <div className={styles.customSection}>
        <p className={styles.searchLabel}>{SEARCH_LABEL}</p>
        <SearchInputSuggestions used='error' />
      </div>
    </div>
  )
}
